<template>
  <span class="thin-text">
    <translate>VERSION</translate>: {{ version }}
  </span>
</template>

<script>
import Vue from 'vue'
import VersionDisplayModel from './versionDisplayModel'
import { observer } from 'mobx-vue'
import packageJson from '../../../package.json'

export default observer(Vue.extend({
  name: 'VersionDisplay',
  data () {
    return {
      state: VersionDisplayModel.getInstance()
    }
  },
  async mounted () {
    const backendVersion = await this.state.fetchBackendVersion()
    const frontendVersion = packageJson.version

    this.state.setBackendVersion(backendVersion)
    this.state.setFrontendVersion(frontendVersion)

    const higherVersion = this.state.compareVersions(backendVersion, frontendVersion)
    this.state.setDisplayVersion(higherVersion)
  },
  computed: {
    version () {
      return this.state.displayVersion
    }
  }
}))
</script>
